export default class Zoom {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Zoom;
		self.attachEvents();
	}

	static initZoom($el) {
		const self = new Zoom;

		self.attachZoom($el);
	}

	attachEvents() {
		const self = this;

		self.attachZoom();

		$('.js-zoom-img').each(function() {
			self.attachZoom($(this));
		});
	}

	attachZoom($el) {
		const self = this;

		$el.zoom({
			url: $el.data('img')
		});
	}
}
